import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ConfigService } from '@core/services';

@Component({
  selector: 'app-page403',
  templateUrl: './page403.component.html',
  styleUrl: './page403.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class Page403Component {
  main_site_url: string;

  constructor(private readonly configService: ConfigService) {
    this.main_site_url = this.configService.postLogoutUri;
  }
}
